import { useQuery } from 'react-query';
import createCachedSelector from 're-reselect';
import * as api from '../../services/api';
import { mappedArray } from '../../utils/array';
import useCRUD from '../useCRUD';
import { SORT_BY_STRING } from '../../utils/sorting';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data = []) => {
    const sorter = SORT_BY_STRING('slug');

    const fields = (data || []).map(({ slug, ...rest }) => ({ slug, name: slug, ...rest })).sort(sorter);
    const mappedFields = mappedArray(data || []);

    return { fields, mappedFields };
  }
)({
  keySelector: (_, storeKey) => `${storeKey.join('#')}`
});

const useTimesheetFields = () => {
  const { accountId } = useAccount();

  const storeKey = ['timesheet-fields', accountId];

  const { isLoading, data } = useQuery(storeKey, () => api.fetchTimesheetFields({ accountId }), {
    select: (timesheetFieldsData) => selector(timesheetFieldsData, storeKey),
    enabled: !!accountId
  });

  const { addItem, editItem, deleteItem } = useCRUD(
    storeKey,
    {
      addApi: (field) => api.addTimesheetField({ accountId, field }),
      editApi: ({ id, ...field }) => api.updateTimesheetField({ accountId, fieldId: id, field }),
      deleteApi: ({ id }) => api.deleteTimesheetField({ accountId, fieldId: id })
    },
    { refetchOnSuccessDelete: true }
  );

  const { fields = [], mappedFields = {} } = data || {};

  return {
    isLoading,
    fields,
    addField: addItem,
    updateField: editItem,
    deleteField: deleteItem,
    editField: editItem,
    mappedFields
  };
};

export default useTimesheetFields;
